<template>
    <div>
        <commonHeader
            v-if="num == 0"
            ref="headerRef"
            @changeOpinion="changeOpinion"
            @changeTable="changeTable"
            @openProjectTable="openProjectTable"
            @searchTable="searchTable"
        />
        <commonTable
            v-if="num == 0"
            :columns="columns"
            :loading="loading"
            :pagination="pagination"
            :tableData="tableData"
            @backProject="backProject"
            @openTable="openTable"
            @pageChange="pageChange"
        />
        <projectTable
            v-if="num == 1"
            @backProject="backProject"
            @goProject="goProject"
        />
        <projectTableBrand
            v-if="num == 2"
            @backProject="backProject"
            @goProject="goProject"
        />
        <projectTableCooperation
            v-if="num == 3"
            @backProject="backProject"
            @goProject="goProject"
        />
    </div>
</template>

<script>
import commonHeader from "@/components/common-header/index.vue";
import commonTable from "@/components/common-table/index.vue";
import projectTable from "@/components/project-table/index.vue";
import projectTableBrand from "@components/project-table-brand";
import projectTableCooperation from "@components/project-table-cooperation";
import {decUserAccessCheckLisApi} from "@/api/declare";

export default {
    components: {commonHeader, commonTable, projectTable, projectTableBrand, projectTableCooperation},
    data() {
        return {
            page: 0,
            year: "2023",
            num: 0 /* 0为默认，1为打开申请表 */,
            tableData: [],
            provinceOpinion: '',
            loading: false,
            pagination: {},
            columns: [
                {
                    title: "序号",
                    dataIndex: "sort",
                    key: "sort",
                    width: 100,
                },
                {
                    title: "项目名称",
                    dataIndex: "projectName",
                    key: "projectName",
                    scopedSlots: {customRender: "projectName"},
                },
                {
                    title: "项目类别",
                    dataIndex: "projectType",
                    key: "projectType",
                },
                {
                    title: "申报单位",
                    dataIndex: "unitName",
                    key: "unitName",
                },
                {
                    title: "单位类别",
                    dataIndex: "unitType",
                    key: "unitType",
                },
                {
                    title: "申报时间",
                    dataIndex: "createAt",
                    key: "createAt",
                    scopedSlots: {customRender: "createAt"},
                },
                // {
                //   title: "状态",
                //   dataIndex: "status",
                //   key: "status",
                //   scopedSlots: { customRender: "status" },
                // },
                {
                    title: "操作",
                    dataIndex: "operation",
                    key: "operation",
                    scopedSlots: {customRender: "operation"},
                },
            ],
        };
    },
    methods: {
        searchTable() {
            this.page = 0;
            this.pagination.current = 1;
            this.getDecInformationMyList();
        },
        goProject() {
            this.num = 0;
            this.getDecInformationMyList();
        },
        pageChange(val) {
            console.log(val);
            this.page = val.current - 1;
            this.getDecInformationMyList();
        },
        changeTable(val) {
            this.year = val;
            this.getDecInformationMyList();
        },
        changeOpinion(val) {
            this.provinceOpinion = val;
            // console.log(this.provinceOpinion);
            this.getDecInformationMyList();

        },
        openTable(num) {
            this.num = num;
        },
        backProject() {
            this.num = 0;
            this.getDecInformationMyList();
        },
        getDecInformationMyList() {
            this.loading = true;
            let obj = JSON.parse(localStorage.getItem("userModel"));
            console.log(this.$refs.headerRef);
            let params = {
                expertId: obj.productUserId,
                type: 0,
                keyword: this.$refs.headerRef ? this.$refs.headerRef.keyWord : "",
                provinceOpinion: this.provinceOpinion,
                year: this.year,
                page: this.page,
                pageSize: 10,
            };
            decUserAccessCheckLisApi(params).then((res) => {
                this.loading = false;
                // console.log(111);
                // console.log(res);
                if (res.status) {
                    res.data.forEach((item, index) => {
                        item.sort = index + 1;
                    });
                    this.tableData = res.data;
                    this.pagination = res.pagination;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        openProjectTable() {
            this.num = 1;
        },
    },
    created() {
        setTimeout(() => {
            this.getDecInformationMyList();
        }, 500);
    },
};
</script>

<style></style>
